import script from "./MemberEventBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberEventBox.vue?vue&type=script&setup=true&lang=ts"

import "./MemberEventBox.vue?vue&type=style&index=0&id=5057b154&lang=scss"

const __exports__ = script;

export default __exports__